import { render } from "./ServicesUpcomingTable.vue?vue&type=template&id=609ac23c"
import script from "./ServicesUpcomingTable.vue?vue&type=script&lang=js"
export * from "./ServicesUpcomingTable.vue?vue&type=script&lang=js"

import "./ServicesUpcomingTable.vue?vue&type=style&index=0&id=609ac23c&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__